module.exports = __webpack_public_path__ + "static/media/Homepage_Restart.ba0755a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/Homepage_Restart.wav
// module id = 5rUo
// module chunks = 1